import type { SVGProps } from 'react'

// Solid check-circle — filled disc with a checkmark cutout. In-family with
// `AlertCircleSolid` (Figma's `check-circle-solid`, Catalyst node `3158:1582`,
// is Code-Connected with no exportable asset, so this is a faithful
// reconstruction in the same solid glyph language). Single `fillRule="evenodd"`
// path so the check cutout shows whatever's behind it; `currentColor` paints
// the disc.
export default function CheckCircleSolid(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.707-12.707a1 1 0 0 1 0 1.414l-5.5 5.5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 1 1 1.414-1.414l1.793 1.793 4.793-4.793a1 1 0 0 1 1.414 0Z"
      />
    </svg>
  )
}
